/**
 * 引数の文字列先頭を大文字へ変換する。
 * @param str 変換する文字列
 * @returns 変換後の文字列
 */
const upperStartStr = (str = '') => {
  if (str.length < 1) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

/**
 * 先頭の文字列が任意の文字列で始まっているかチェックする。
 * @param targetStr 確認する文字列
 * @param checkStr 先頭の文字列
 * @returns
 */
const startWith = (targetStr = '', checkStr = '') => {
  if (targetStr && !checkStr) return false;
  return targetStr.startsWith(checkStr);
};

export const stringUtils = {
  upperStartStr,
  startWith
};
